import { render, staticRenderFns } from "./MarketPurchase.vue?vue&type=template&id=a1469c48&scoped=true&"
import script from "./MarketPurchase.vue?vue&type=script&lang=js&"
export * from "./MarketPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MarketPurchase.vue?vue&type=style&index=0&id=a1469c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1469c48",
  null
  
)

export default component.exports